import { TRIP_USING } from '../constants/search-config.constant';

export interface TripsRequest {
  using: TRIP_USING;
  confirmationNum?: string;
  ticketNum?: string;
  creditCardNum?: string;
  givenNames: string;
  surname: string;
}

export interface TripFlags {
  flags: Flags;
}

export interface Flags {
  creditCardSearch: boolean;
  pnrSearch: boolean;
  pnrListSearch: boolean;
  paymentReference: boolean;
}

export interface CreditRequest {
  referenceId: string;
  fName: string;
  lName: string;
  app: string;
}
